module.exports = __webpack_public_path__ + "static/farmyard1-a0b7eccea255dbb341390b602cbae959.png";